import { Box } from '@mui/material';
import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityTranslation } from '@procureai/curiosity-ui-mui';

import { useDataGridContext } from '../../hooks/useDataGridContext';
import { getRowId } from '../../util/internalRowIds';
import { UserAutocomplete, UserEntity } from '~/components/UserAutocomplete';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

export interface UserSelectCellContext {
  onUserChange: (rowId: GridRowId, user: CuriosityTranslation<UserEntity> | string | null) => Promise<void>;
}

export type UserSelectCellValue = string | CuriosityTranslation<UserEntity> | null | undefined;

interface UserSelectCellProps<R extends GridValidRowModel = any> {
  value: UserSelectCellValue;
  row: R;
  simplifyValue?: boolean;
}

export const CuriosityUserSelectCell = <R extends GridValidRowModel = any>({
  value,
  row,
  simplifyValue,
}: UserSelectCellProps<R>) => {
  const { onUserChange } = useDataGridContext<UserSelectCellContext>();
  if (!onUserChange) {
    throw new Error('CuriosityUserSelectCell: DataGridContextProvider must provide a onUserChange method');
  }

  return (
    <Box
      onClick={eventStopPropagation}
      sx={{
        flex: 1,
      }}
    >
      <UserAutocomplete
        simplifyValue={simplifyValue}
        fullWidth={true}
        size="small"
        value={value || null}
        onChange={(value) => {
          onUserChange(getRowId(row), value);
        }}
      />
    </Box>
  );
};
